/* eslint-env browser */
import { NAVIGATION_OFFSET_SELECTOR } from 'Components/widgets/navigation/Navigation.constants';

export function goToHash(hash, scrollUnderNav = true) {
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */
  function scrollUnderNavBar() {
    const navBar = document.getElementsByClassName(NAVIGATION_OFFSET_SELECTOR)[0];
    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    const hashName = hash.split('#')[1];
    setTimeout(() => {
      const element = document.getElementById(hashName);
      if (element) {
        element.scrollIntoView();
      }

      if (scrollUnderNav) {
        scrollUnderNavBar();
      }
    }, 100);
  }
}
